/* eslint-disable quotes */
import { h } from 'vue';
import { vimeo } from '../../vimeo';

const body = `<h4>Manage Tangents</h4>

<p>Display and work with tangency vectors, using the buttons of the menu below.</p>

<!--
<div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="${vimeo('703231606')}"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
</div>
-->

<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'><b>T:</b> Manage Tangents</li>
</ul>`;

export default function TangentTooltip() {
    return h('div', { innerHTML: body });
}
